import { IconProps } from './types';

export const FeedIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15.764 18.449'>
    <path
      d='M11.632,0,4.5,7.132v9.509H9.255V11.887h4.755v4.755h4.755V7.061Z'
      transform='translate(-3.75 1.058)'
      fill='none'
      stroke='#fff'
      strokeWidth='1.5'
      {...props}
    />
  </svg>
);
